module.exports = __webpack_public_path__ + "img/helal-ahmar.9ec1884.webp";